import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "./auth";
import "../css/nav.css";

export const Navbar = () => {
  const { user, logout } = useAuth();
  return (
    <div className="nav-container">
      <nav className="navbar-cls">
        <NavLink to="/">Home</NavLink>
        <NavLink to="Dashboard">Catalogue</NavLink>
        <NavLink to="MyDashboard">Dashboard</NavLink>
        {user ? (
          <NavLink to="/" onClick={logout}>
            Logout
          </NavLink>
        ) : (
          <NavLink to="/login">Login</NavLink>
        )}
      </nav>
    </div>
  );
};
